import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

export const createMarginManagement = async (marginManagementData) => {
  try {
    const res = await API.create_margin_management(marginManagementData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const updateMarginManagement = async (
  marginManagementId,
  marginManagementData,
) => {
  try {
    const res = await API.update_margin_management(
      marginManagementId,
      marginManagementData,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getMarginManagementData = async (marginManagementId) => {
  try {
    const res = await API.get_margin_management_data(marginManagementId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const marginManagementList = async (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.margin_management_list(
      pageNum,
      filters,
      searchString,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
